module.exports = __webpack_public_path__ + "static/media/banner_front2-05.bd53368b.png";